import {CONSTANTS} from "../common/constants";
import Checkbox from "@mui/material/Checkbox";
import React, {useEffect, useState} from "react";
import {formatAge, sortAttendeesFunction} from "../common/Utils";
import {Grid} from "@mui/material";
import MDButton from "../../components/MDButton";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import {getCustomerFamilyAll} from "../common/api/WebApi";
import ManageFamilyMemberModal from "../client/ManageFamilyMemberModal";
import {saveCustomerFamily} from "../common/api/CustomerProfileApi";


export default function LockedAccountForm({inventory, siblingQuantity, client, callback}) {
  const [membershipMemberAdults, setMembershipMemberAdults] = useState([]);
  const [membershipMemberChildren, setMembershipMemberChildren] = useState([]);
  const [membershipMembers, setMembershipMembers] = useState([]);
  const [addFamily, setAddFamily] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [savingFamilyMember, setSavingFamilyMember] = useState(false);

  const doGetCustomerFamily = () => {
    getCustomerFamilyAll(client?.guid).then((resp) => {
      setFamilyMembers(resp?.familyMembers);
    })
  }
  useEffect(() => {
    if (!client || !client?.guid) {
      return;
    }
    doGetCustomerFamily()
  }, [client]);

  useEffect(() => {
    setMembershipMemberChildren([]);
  }, [siblingQuantity]);

  useEffect(() => {
    callback({
      membershipMembers: membershipMembers
    })
  }, [membershipMembers]);

  useEffect(() => {
    setMembershipMembers(inventory?.membershipMembers);
  }, [inventory?.membershipMembers]);

  useEffect(() => {
    let arr = [];
    for (let j in membershipMemberAdults) {
      arr.push(membershipMemberAdults[j]);
    }
    for (let j in membershipMemberChildren) {
      arr.push(membershipMemberChildren[j]);
    }
    setMembershipMembers(arr);
  }, [membershipMemberAdults, membershipMemberChildren]);

  useEffect(() => {
    if (inventory?.membershipMembers?.length === 0) {
      return;
    }
    if (familyMembers?.length === 0) {
      return;
    }

    let memberChildren = [];
    let memberAdults = [];

    for (const ff in inventory?.membershipMembers) {
      for (const f in familyMembers) {
        if (inventory?.membershipMembers[ff] === familyMembers[f]?.guid) {
          if (familyMembers[f].familyMemberType?.id === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD) {
            memberChildren.push(familyMembers[f].guid);
          } else {
            memberAdults.push(familyMembers[f].guid);
          }
        }
      }
      setMembershipMemberChildren(memberChildren);
      setMembershipMemberAdults(memberAdults);
    }

  }, [inventory, familyMembers]);

  const toggleAdults = (guid) => {
    setMembershipMemberAdults(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  const toggleChildren = (guid) => {
    setMembershipMemberChildren(prev =>
      prev.includes(guid)
        ? prev.filter(id => id !== guid)
        : [...prev, guid]
    );
  };

  const handleSaveFamilyMember = async (member) => {
    setSavingFamilyMember(true);
    member.parentGuid = client.guid;
    let result = await saveCustomerFamily(member);
    setSavingFamilyMember(false);
    setAddFamily(false);
    doGetCustomerFamily();
  }

  return (<>
    <div style={{
    display: 'block',
    margin: '10px 0'
  }}>

    {<>

      {familyMembers?.length > 0 && <>

        <h5>{inventory?.name} - Assign Members</h5>

        {inventory?.accountType?.familyPass && <div>

          {inventory?.numAdults > 0 && <div className={'d-block mb-4'}>
            <p><b>Assign up to {inventory?.numAdults} Adults</b></p>
            <ul className={'list-group'}>
              {familyMembers.sort(sortAttendeesFunction).filter((f) => f.familyMemberType?.id !== CONSTANTS.FAMILY_MEMBER_TYPE.CHILD).map((f, idx) => {
                return (<li key={idx} className={'list-group-item'} style={{
                    background: (!membershipMemberAdults.includes(f.guid) && membershipMemberAdults?.length === ((inventory.numAdults ? inventory.numAdults : 0)) ? '#eaeaea' : '#fff')
                  }}>
                    <Checkbox checked={membershipMemberAdults.includes(f.guid)}
                              disabled={!membershipMemberAdults.includes(f.guid) && membershipMemberAdults?.length === inventory.numAdults}
                              onChange={() => {
                                toggleAdults(f.guid);
                              }}
                    />&nbsp;
                    {f.firstName} {f.lastName}
                  </li>
                )
              })
              }
            </ul>
          </div>}

          {inventory?.numChildren > 0 && <div className={'d-block mb-2'}>
            <p><b>Assign up to {inventory?.numChildren} Children</b></p>
            <ul className={'list-group'}>
              {familyMembers.sort(sortAttendeesFunction).filter((f) => f.familyMemberType?.id === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD).map((f, idx) => {
                return (<li key={idx} className={'list-group-item'} style={{
                    background: (!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length === ((inventory.numChildren ? inventory.numChildren : 0)) ? '#eaeaea' : '#fff')
                  }}>
                    <Checkbox checked={membershipMemberChildren.includes(f.guid)}
                              disabled={!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length === inventory.numChildren}
                              onChange={() => {
                                toggleChildren(f.guid);
                              }}
                    />&nbsp;
                    {f.firstName} {f.lastName} <span
                    className={'font-smaller'}>{f?.dob && ' (' + formatAge(f) + ')'}</span>
                  </li>
                )
              })
              }
            </ul>
          </div>}

        </div>}


        {!inventory?.accountType?.familyPass && <div>
          <div className={'d-block mb-2'}>
            <ul className={'list-group'}>
              {familyMembers.sort(sortAttendeesFunction).filter((f) => f.familyMemberType?.id === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD).map((f, idx) => {
                return (<li key={idx} className={'list-group-item'} style={{
                    background: (!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length >= ((siblingQuantity ? siblingQuantity : 0)) ? '#eaeaea' : '#fff')
                  }}>
                    <Checkbox checked={membershipMemberChildren.includes(f.guid)}
                              disabled={!membershipMemberChildren.includes(f.guid) && membershipMemberChildren?.length >= (siblingQuantity ? siblingQuantity : 0)}
                              onChange={() => {
                                toggleChildren(f.guid);
                              }}
                    />&nbsp;
                    {f.firstName} {f.lastName} <span
                    className={'font-smaller'}>{f?.dob && ' (' + formatAge(f) + ')'}</span>
                  </li>
                )
              })
              }
            </ul>
          </div>
        </div>}
      </>}

      <Grid item xs={12}>
                                  <span className={'pull-right'}>
                                    <MDButton
                                      variant="outlined"
                                      color="secondary"
                                      size="small"
                                      onClick={() => {
                                        setAddFamily(true);
                                      }}>
                                    <PersonAddIcon/>&nbsp;Add Family Member
                                  </MDButton>
                                </span>
      </Grid>

    </>
    }

  </div>
    {addFamily && <ManageFamilyMemberModal
      show={addFamily}
      embedded={true}
      saving={savingFamilyMember}
      handleSaveFamilyMember={(obj)=> {
        handleSaveFamilyMember(obj)
      }}
      handleCloseFamilyMember={()=>{
        setAddFamily(false);
      }}/>
    }

    </>)
}